import { MatchingType } from '../../types/EquipmentTypes';

export default {
  title: 'Regulatory Compliance and Commercial Inspections',
  items: [
    {
      title: '3D Scanning',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: '3D Scanning',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Ballast Water Sampling',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: 'Ballast Water Sampling',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Bar Code Spares Inventory',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: 'Bar Code Spares Inventory',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Condition Assessment Surveys',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: 'Condition Assessment Surveys',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Exhaust Cleaning System Analysis',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: 'Exhaust Cleaning System Analysis',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Hazardous Material Inventory',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: 'Hazardous Material Inventory',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Incident Investigations',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: 'Incident Investigations',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Oil Analysis',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: 'Oil Analysis',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Pre-Purchasing Surveys',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: 'Pre-Purchasing Surveys',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'SCR NOx Spot Check',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: 'SCR NOx Spot Check',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Sea Trials',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: 'Sea Trials',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Sludge/Slop/Bilge Shore Facility Discharge',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: 'Shore Facility Discharge',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Unannouced Drug and Alcohol Test',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: 'Unannouced Drug and Alcohol Test',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Water Analysis',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: 'Water Analysis',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Welding Safety Inspection',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: 'Welding Safety Inspection',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
  ],
};
